import React from 'react';
import { Card, CardHeader, CardBody, Col, Alert } from 'reactstrap';
import SignUpForm from './form';
import AppLogo from './../../../assets/img/brand/logo.jpeg';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';
import queryString from 'query-string';
import InvitationDescription from '@/components/InvitationDescription';
import { useSelector } from 'react-redux';
import { Text, textVariantsEnum, fontWeightEnum } from 'components/Text';
import styles from './Signup.module.scss';
const SignUp = () => {
  const location = useLocation();
  const { i: invitationId, t: inviteToken } = queryString.parse(
    location.search
  );
  const invitationData = useSelector(
    (state) => state.invitation?.invitationData
  );

  // Use the URL params for this, not redux — redux gets set by a
  // useEffect on the previous page and isn't always ready by the time
  // we land here, which was silently breaking invite signups.
  const hasInviteParams = !!(invitationId && inviteToken);

  // Redux is only used below for prefilling the name/email and banner —
  // fine if that's briefly empty, it's just cosmetic.
  const inviteMatches =
    hasInviteParams &&
    invitationId === invitationData?.invitationId &&
    !invitationData?.userDetails?.registered;

  const defaultEmail = inviteMatches
    ? String(
        invitationData?.inviteeEmail || invitationData?.userDetails?.email || ''
      ).trim()
    : '';

  const defaultFullName =
    inviteMatches && invitationData?.inviteeName
      ? String(invitationData.inviteeName).trim()
      : '';

  return (
    <>
      <Col lg="5" md="7">
        <Card className="bg-white shadow border-0">
          <CardHeader className="bg-transparent border-0">
            <div className="text-center">
              <img className="auth-app-logo" src={AppLogo} alt="workfromhome" />
            </div>

            <div className={styles.signupHeader}>
              <Text
                variant={textVariantsEnum.Text_25}
                fontWeight={fontWeightEnum.Semibold}
                style={{ color: '#000' }}
              >
                {' '}
                Sign Up
              </Text>
              <Text
                variant={textVariantsEnum.Display_xs}
                style={{ color: '#343942' }}
              >
                Create your account
              </Text>
            </div>
            {inviteMatches && (
              <div className="mt-3">
                <Alert color="primary">
                  <InvitationDescription
                    invitationData={invitationData}
                    variant="signup"
                  />
                </Alert>
              </div>
            )}
          </CardHeader>
          <CardBody className="px-lg-5 pb-lg-5 pt-lg-1">
            <SignUpForm
              defaultEmail={defaultEmail}
              defaultFullName={defaultFullName}
              inviteId={hasInviteParams ? invitationId : null}
              inviteToken={hasInviteParams ? inviteToken : null}
            />
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default SignUp;
